import { render } from "./ManageView.vue?vue&type=template&id=d8d006ce&scoped=true"
import script from "./ManageView.vue?vue&type=script&lang=js"
export * from "./ManageView.vue?vue&type=script&lang=js"

import "./ManageView.vue?vue&type=style&index=0&id=d8d006ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d006ce"]])

export default __exports__